<template>
	<v-card ref="cardRef" class="kpi-detail-card" flat>
		<v-card-title class="kpi-detail-card__title">
			<div class="kpi-detail-card__heading">
				<div class="kpi-detail-card__title-text">
					<v-icon>insights</v-icon>
					{{ title }}
				</div>

				<div class="d-flex ga-2 ml-2">
					<v-chip readonly>
						<v-icon>storefront</v-icon>
						{{ count }} {{ t('DeliveryLocations') }}
					</v-chip>
					<slot name="chips" />
				</div>
				<slot name="groups" />
			</div>
			<div class="kpi-detail-card__toolbar">
				<v-text-field :model-value="search" @update:model-value="$emit('update:search', $event)" :label="t('Search')" density="compact" variant="outlined" prepend-inner-icon="search" clearable hide-details />
				<v-tooltip :attach="overlayTarget" location="bottom">
					<template #activator="{ props: tooltipProps }">
						<v-btn v-bind="tooltipProps" :icon="isFullscreen ? 'fullscreen_exit' : 'fullscreen'" variant="tonal" density="comfortable" @click="toggleFullscreen" />
					</template>
					<span>{{ isFullscreen ? t('ExitFullscreen') : t('Fullscreen') }}</span>
				</v-tooltip>
			</div>
		</v-card-title>
		<v-card-text>
			<slot />
		</v-card-text>
	</v-card>
</template>

<script setup>
import { ref, inject } from 'vue';
import { useTranslator } from '@/composables/useTranslator';

const t = useTranslator();
const overlayTarget = inject('overlayTarget', null);

defineProps({
	title: { type: String, default: '' },
	count: { type: Number, default: 0 },
	search: { type: String, default: '' },
});

const emit = defineEmits(['update:search', 'toggle-fullscreen']);

const cardRef = ref(null);
const isFullscreen = ref(false);

function toggleFullscreen() {
	const el = cardRef.value?.$el ?? cardRef.value;
	if (!el) return;
	isFullscreen.value = !isFullscreen.value;
	el.classList.toggle('kpi-detail-card--fullscreen', isFullscreen.value);
	emit('toggle-fullscreen', isFullscreen.value);
}

defineExpose({
	get el() {
		return cardRef.value?.$el ?? cardRef.value;
	},
});
</script>
